import React from 'react'
import { func, object } from 'prop-types'

import { Grid, Row, Col } from 'react-bootstrap'

import InputBlock from 'coact/InputBlock'
import Block from 'coact/Block'


function HeadEditor (props) {
  const { spliter, style, value, brandOptionsFilter } = props
  const getChildProps = spliter(props)

  return (
    <div className={style['form-head']}>
      <Grid>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('customerRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('brandRef')} filterOptions={brandOptionsFilter} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('stafferRef')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('orderStafferRef')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('orderType')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('companyRef')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('key')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('custOrderNo')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('orderDate')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('salesRegion')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('salesRepName')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('salesRepPhone')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('customerName')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('customerAddress')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('customerGroup')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('printPrice')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('deliveryNote')} />
          </Col>
          <Col md={4}>
            <InputBlock {...getChildProps('billDate')} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputBlock {...getChildProps('deleteOrder')} />
          </Col>
          <Col md={4}>
            <Block name="總金額">
              <span>{value.total}</span>
            </Block>
          </Col>
          <Col md={4}>
            <Block name="數量合計">
              <span>{value.summary}</span>
            </Block>
          </Col>
        </Row>
      </Grid>
    </div>
  )
}

HeadEditor.propTypes = {
  spliter: func.isRequired,
  value: object,
  brandOptionsFilter: func.isRequired,
  style: object.isRequired,
}

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/HeadEditor/HeadEditor.jsx